import { render, staticRenderFns } from "./SocialMediaInput.vue?vue&type=template&id=a9af54ca&"
import script from "./SocialMediaInput.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports